// Module preload polyfill for non-HTML entries
import "vite/modulepreload-polyfill";
import "../scss/style.scss";
import * as bootstrap from "bootstrap";
import $ from "jquery";

// Make bootstrap available globally for legacy code
window.bootstrap = bootstrap;

import moment from "moment";
import "./vendor/julian.js";
import { initialize } from "./PortalApp";

// Async initialization function
async function initializeApp() {
  // Set globals for legacy code
  window.$ = window.jQuery = $;
  window.moment = moment;
  window.Moment = moment;

  // Load Popper asynchronously
  const { default: Popper } = await import("@popperjs/core");
  window.Popper = Popper;

  // Initialize app
  initialize();
}

// Initialize when DOM is ready using vanilla JavaScript
document.addEventListener("DOMContentLoaded", () => {
  initializeApp().catch((error) => {
    console.error("Failed to initialize app:", error);
  });
});
